import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
// import { TitleCasePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.css']
})
export class CustomerFormComponent implements OnInit { 
  data: any = {};
  c: any = {};
  stateList: any=[]; 
  s: any = {};
  districtList: any=[];
  d: any = {}; 
  CUST_ID: any;
  mode: any;
  title: any;
  Code: any;
  formInvalid : boolean = false;
  formSubmitted:boolean;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
   ) {
  }

  ngOnInit() {
   this.GetStateCustomerModel()
   this.GetDistrictCustomerModel(this.ST_Id)
   
    this.route.params.subscribe(params => {
      this.CUST_ID = params['CUST_ID'];
      this.mode = params['mode'];

      if (this.CUST_ID > 0) {

        this.GetByIdCustomerModel(this.CUST_ID)
      }
    });
    if (this.mode == 'View') {
      this.title = "View Caste ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Caste ";
    }
  }
  ST_Id(ST_Id: any) {
    throw new Error("Method not implemented.");
  }

  GetStateCustomerModel() {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetStateCustomer();
    this.data.subscribe(
      (response: any) => {
        this.stateList = response.Result;
          document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetDistrictCustomerModel(ST_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetDistrictCustomer(ST_Id);
    this.data.subscribe(
      (response: any) => {
        this.districtList = response.Result;
          document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetByIdCustomerModel(CUST_ID) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdCustomerModel(CUST_ID);
    this.data.subscribe(
      (response: any) => {
        this.c = response;
         this.GetDistrictCustomerModel(this.c.CUST_ST_ID);
          document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
           document.getElementById('loader-spinner').style.display = "none";
      });
  }

  CreateCustomer(Customer: NgForm){ 
    debugger;   
    // if(Customer.invalid)
    // {
    //   this.formInvalid = true;
    //   swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    //   return;
    // }     

    // else{                                     
            this.data = this.userService.CreateCustomer(Customer.value);    
            this.data.subscribe(
            (response) => {
              Customer.reset();
              Customer.resetForm();
              Customer.form.markAsPristine();
              Customer.form.markAsUntouched();        
              swal('Success!', 'Customer Details Added Successfully .', 'success');
              this.router.navigate(['/home/customer-master']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
        // } 
  }

  UpdateCustomer(Customer: NgForm) {
    debugger;
    this.data = this.userService.UpdateCustomer(this.CUST_ID,Customer.value);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Customer details updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        this.router.navigate(['/home/customer-master']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
      });
  }
  Cancel() {
  this.c={};
  }
}



// WEBPACK FOOTER //
// ./src/app/recovery/customer/customer-form/customer-form.component.ts